import { render, staticRenderFns } from "./DsnRouterHistory.vue?vue&type=template&id=d871c3bc&"
import script from "./DsnRouterHistory.vue?vue&type=script&lang=js&"
export * from "./DsnRouterHistory.vue?vue&type=script&lang=js&"
import style0 from "./DsnRouterHistory.vue?vue&type=style&index=0&lang=scss&scoep=true&"
import style1 from "./DsnRouterHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports